import { extendTheme } from "@chakra-ui/react"

import { Accordion } from "./components-style-overrides/accordion-definition"
import { Alert } from "./components-style-overrides/alert-definition"
import { Button } from "./components-style-overrides/button-definition"
import { Checkbox } from "./components-style-overrides/checkbox-definition"
import { Divider } from "./components-style-overrides/divider-definition"
import { Drawer } from "./components-style-overrides/drawer-definition"
import { FormLabel } from "./components-style-overrides/form-label-definition"
import { Input } from "./components-style-overrides/input-definition"
import { Modal } from "./components-style-overrides/modal-definition"
import { NumberInput } from "./components-style-overrides/number-definition"
import { Radio } from "./components-style-overrides/radio-definition"
import { Select } from "./components-style-overrides/select-definition"
import { Switch } from "./components-style-overrides/switch-definition"
import { Table } from "./components-style-overrides/table-definition"
import { Tabs } from "./components-style-overrides/tabs-definition"
import { Tag } from "./components-style-overrides/tag-definition"
import { Textarea } from "./components-style-overrides/textarea-definition"
import { Tooltip } from "./components-style-overrides/tooltip-definition"
import {
  colors,
  fontSizes,
  fontWeights,
  fonts,
  letterSpacings,
  lineHeights,
  radii,
  shadows,
  sizes,
  textStyles,
} from "./values"

export const theme = extendTheme({
  colors,
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
  radii,
  shadows,
  sizes,
  textStyles,
  // Chakra's own defaults (body text, borders, placeholders) follow the design system.
  semanticTokens: {
    colors: {
      "chakra-body-text": { _light: "text" },
      "chakra-body-bg": { _light: "surface" },
      "chakra-border-color": { _light: "line" },
      "chakra-inverse-text": { _light: "textInverse" },
      "chakra-subtle-bg": { _light: "surfaceAlt" },
      "chakra-subtle-text": { _light: "textMuted" },
      "chakra-placeholder-color": { _light: "textSubtle" },
    },
  },
  styles: {
    global: {
      body: {
        fontFamily: "body",
        color: "text",
        bg: "surface",
        WebkitFontSmoothing: "antialiased",
      },
      "*:focus-visible": {
        outline: "2px solid",
        outlineColor: "focus",
        outlineOffset: "2px",
      },
      "@media (prefers-reduced-motion: reduce)": {
        "*, *::before, *::after": {
          transitionDuration: "1ms !important",
          animationDuration: "1ms !important",
        },
      },
    },
  },
  components: {
    Accordion,
    Alert,
    Button,
    Divider,
    Drawer,
    Tag,
    Input,
    NumberInput,
    Textarea,
    Tabs,
    FormLabel,
    Modal,
    Radio,
    Select,
    Switch,
    Table,
    Tooltip,
    Checkbox,
  },
})
